import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import DraftUploader from '../../../../../../FormComponents/DraftUploader'
import { useParams } from 'react-router-dom'
import { toastError, toastSuccess } from '../../../../../../FormComponents/Toasts'
import { Trash3 } from 'react-bootstrap-icons'
import axiosService from '../../../../../../../utils/AxiosService'
import InsightUpload from '../../../../../../../models/InsightUpload'
import { useReadOnly } from '../../../../../../../contexts/ReadOnlyContext'

export default observer(function InsightUploadSelectPanel({ insight }) {
  const [selectedUpload, setSelectedUpload] = useState(null)
  const { id } = useParams()
  const readOnly = useReadOnly()

  useEffect(() => {
    if (insight?.insight_uploads?.length > 0) {
      setSelectedUpload(insight.insight_uploads[0])
    }
  }, [insight?.insight_uploads?.length])

  const deleteUpload = () => {
    axiosService.delete(
      `/api/project_manager/campaigns/${id}/actions/${insight.action_id}/action_insights/${insight.id}/insight_uploads/${selectedUpload.id}`
    )
    .then(() => {
      toastSuccess(`Upload deleted!`)
      insight.insight_uploads = insight.insight_uploads.filter(upload => +upload.id !== +selectedUpload.id)
      // Set the new selected upload after deletion
      if (insight.insight_uploads.length > 0) {
        setSelectedUpload(insight.insight_uploads[0])
      } else {
        setSelectedUpload(null)
      }
    })
    .catch(error => console.log(error))
  }
 
  return (
    <div className='my-5 p-3 pb-0 bg-white rounded-lg'>
      <div className='flex justify-between items-center'>
        <h3 className='mb-2 pt-1 font-bold text-md'>{selectedUpload?.fileName || 'No uploads'}</h3>
        {!readOnly && (
          <div className='flex gap-2'>
            <button
              className='flex items-center hover:bg-gray-100 rounded-lg p-2'
              onClick={(e) => {
                e.preventDefault()
                if (selectedUpload) {
                  deleteUpload()
                }
              }}
            >
              <Trash3 />
            </button>
          </div>
        )}
      </div>
      <div className='flex items-center justify-start gap-4 min-w-full overflow-x-scroll'>
        {
          insight?.insight_uploads.map((upload) => (
            <button
              key={upload.id}
              type='button'
              onClick={() => {
                setSelectedUpload(upload)
              }}
              className='relative'
            >
              <img
                src={upload.url}
                alt={upload.fileName}
                className={`${selectedUpload?.id === upload.id ? 'border-2 border-rb-green' : ''} h-12 min-w-12 max-w-12 rounded-lg object-cover`}
              />
            </button>
          ))
        }
        {!readOnly && <div className='min-h-12 min-w-12'>
          <DraftUploader
            isCompact
            url={`/api/project_manager/campaigns/${id}/actions/${insight.action_id}/action_insights/${insight.id}/insight_uploads`}
            onDocumentUpload={(response) => {
              response.forEach(upload => {
                const newUpload = new InsightUpload(upload)
                insight.insight_uploads.push(newUpload)
              })
              const fileCount = response.length
              toastSuccess(`${fileCount} ${fileCount === 1 ? 'upload' : 'uploads'} added!`)
            }}
            onDocumentUploadFailure={(error) => toastError(error)}
          />
        </div>}
      </div>
      { selectedUpload && (
        <div className='mt-4 w-full border-1 border-primary rounded-md'>
          <img
            src={selectedUpload?.url}
            alt={selectedUpload?.fileName}
            className='w-full rounded-md object-contain'
          />
        </div>
      )}
    </div>
  )
})